import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export type Theme = "white" | "gray";

export interface Props {
  theme?: Theme;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseWidgetTemplate',
  props: {
    theme: { default: "white" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["base-widget-template", [_ctx.theme]])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})